import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchUserProfile = createAction(constants.FETCH_USER_PROFILE)
export const fetchUserProfilePending = createAction(
  constants.FETCH_USER_PROFILE_PENDING
)
export const fetchUserProfileSuccess = createAction(
  constants.FETCH_USER_PROFILE_SUCCESS
)
export const fetchUserProfileFailed = createAction(
  constants.FETCH_USER_PROFILE_FAILED
)

export const patchUserProfile = createAction(constants.PATCH_USER_PROFILE)
export const patchUserProfilePending = createAction(
  constants.PATCH_USER_PROFILE_SUCCESS
)
export const patchUserProfileSuccess = createAction(
  constants.PATCH_USER_PROFILE_PENDING
)
export const patchUserProfileFailed = createAction(
  constants.PATCH_USER_PROFILE_FAILED
)
